import {
    NEW_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
    CANCEL_ESTAGIO_APLICACAO_CADASTRO_RAPIDO,
    CANCEL_ESTAGIO_APLICACAO_CADASTRO_RAPIDO_SUCCESS,
    TABLE_ESTAGIO_APLICACAO_CADASTRO_PENDING,
    TABLE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
    TABLE_ESTAGIO_APLICACAO_CADASTRO_FAILURE,
    LIST_ESTAGIO_APLICACAO_CADASTRO_PENDING,
    LIST_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
    LIST_ESTAGIO_APLICACAO_CADASTRO_FAILURE,
    FIND_ESTAGIO_APLICACAO_CADASTRO_PENDING,
    FIND_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
    FIND_ESTAGIO_APLICACAO_CADASTRO_FAILURE,
    DELETE_ESTAGIO_APLICACAO_CADASTRO_PENDING,
    DELETE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
    DELETE_ESTAGIO_APLICACAO_CADASTRO_FAILURE,
    CREATE_ESTAGIO_APLICACAO_CADASTRO_PENDING,
    CREATE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS,
    CREATE_ESTAGIO_APLICACAO_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function estagioAplicacaoCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_ESTAGIO_APLICACAO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_ESTAGIO_APLICACAO_CADASTRO_PENDING:
        case FIND_ESTAGIO_APLICACAO_CADASTRO_PENDING:
        case DELETE_ESTAGIO_APLICACAO_CADASTRO_PENDING:
        case CREATE_ESTAGIO_APLICACAO_CADASTRO_PENDING:
        case TABLE_ESTAGIO_APLICACAO_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_ESTAGIO_APLICACAO_CADASTRO_RAPIDO:
        case CANCEL_ESTAGIO_APLICACAO_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_ESTAGIO_APLICACAO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_ESTAGIO_APLICACAO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_ESTAGIO_APLICACAO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_ESTAGIO_APLICACAO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_ESTAGIO_APLICACAO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_ESTAGIO_APLICACAO_CADASTRO_SUCCESS:
        case CREATE_ESTAGIO_APLICACAO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_ESTAGIO_APLICACAO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { estagioAplicacaoCadastroReducer };